import { render, staticRenderFns } from "./faceIngChat.vue?vue&type=template&id=16bca8b6&scoped=true"
import script from "./faceIngChat.vue?vue&type=script&lang=js"
export * from "./faceIngChat.vue?vue&type=script&lang=js"
import style0 from "./faceIngChat.vue?vue&type=style&index=0&id=16bca8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bca8b6",
  null
  
)

export default component.exports